import { HomeIcon } from "@heroicons/react/24/solid";
import { MagnifyingGlassCircleIcon } from "@heroicons/react/24/solid";
import { Link, useLocation } from "react-router-dom";
import ci from "../../assets/images/kbg_ci.png";
import { queryId } from "../UrlValidation";

const IsFirstCharNumeric = () => {
  const location = useLocation();
  const queryValue = new URLSearchParams(location.search).get(queryId); // 쿼리스트링 추출
  const firstChar = queryValue!.charAt(0);
  return /^[0-9]$/.test(firstChar);
};

export default function Header() {
  const location = useLocation();
  return (
    <div className="flex justify-between items-center mb-8 py-2 md:px-20 h-16">
      {/* <div className="flex-1 p-4 bg-red-200">Item 1</div>
      <div className="flex-2 p-4 bg-green-200">Item 2</div>
      <div className="flex-1 p-4 bg-blue-200">Item 3</div> */}
      {/* <Link to={`/festa${location.search}`}> */}
      <img
        src={ci}
        alt="home"
        width="50"
        height="50"
        style={{ pointerEvents: "none" }}
      />
      {/* </Link> */}
      <div
        className={
          IsFirstCharNumeric()
            ? "w-2/5 md:w-5/12" // 아니면 기존 비율 유지
            : "w-full md:w-full mx-5" // 숫자로 시작하면 가득 채움
        }
      >
        {/* <Link to={`/festa/search-product${location.search}`}> */}
        <div className="flex justify-center items-center text-gray-700 rounded border-gray-500 bg-slate-200 h-10">
          <MagnifyingGlassCircleIcon className="w-8 ml-4" />
          <span className="font-bold p-1 mr-4">상품 검색</span>
        </div>
        {/* </Link> */}
      </div>

      {IsFirstCharNumeric() ? (
        <div className="w-2/5 md:w-5/12">
          <Link to={`/festa/search-experience${location.search}`}>
            <div className="flex justify-center items-center text-gray-700 rounded border-gray-500 bg-slate-200 h-10">
              <HomeIcon className="w-8 ml-4" />
              <span className="font-bold p-1 mr-4">체험관</span>
            </div>
          </Link>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
